export default "__VITE_ASSET__CbGBjeDf__"